<template>
  <el-dialog
    class="uploadIMG"
    title="添加图片(只能添加jpg,jpeg,gif,png,大小不超过1MB)"
    :visible.sync="dialogVisible"
    :lock-scroll="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :show-close="true"
    center
    width="800px"
    @close="closeDialog"
  >
    <div class="uploadIMGBody">
      <!-- 左侧导航 -->
      <div class="left-nav">
        <div
          class="nav-item"
          :class="{ active: activeTab === 'myFiles' }"
          @click="activeTab = 'myFiles'"
        >
          我的文件
        </div>
        <div
          v-if="isImageLib"
          class="nav-item"
          :class="{ active: activeTab === 'imageLibrary' }"
          @click="activeTab = 'imageLibrary'"
        >
          图片库
        </div>
      </div>

      <!-- 右侧内容 -->
      <div class="right-content">
        <!-- 我的文件 -->
        <div v-if="activeTab === 'myFiles'" class="my-files">
          <div class="upload-area">
            <UploadImg
              :file-list="uploadedFiles"
              :limit="3"
              accept="image/jpg,image/png,image/jpeg"
              :file-size="5"
              tip-text="支持JPG/PNG/JPEG格式，单文件不超过5M"
              @upload-success="handleUploadSuccess"
            />
            <!-- <el-upload
              class="upload-demo"
              drag
              action="#"
              :before-upload="beforeUpload"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传jpg/jpeg/gif/png文件，且不超过1MB
              </div>
            </el-upload> -->
          </div>

          <!-- 已上传文件列表 -->
          <div class="uploaded-files">
            <div class="files-title">已上传文件</div>
            <div class="files-list">
              <div
                v-for="(file, index) in uploadedFiles"
                :key="index"
                class="file-item"
                :class="{ active: selectedSrc === file.url }"
                @click="selectImage(file)"
              >
              <!-- 加载占位图 :placeholder="require('@/assets/images/loading.png')"
                 加载失败图 :error="require('@/assets/images/error.png')" -->
                <el-image
                  :src="file.url"
                  :preview-src-list="uploadedFiles.map((item) => item.url)"
                  fit="fill/cover/contain/scale-down/center"
                  lazy
                 
                />
                <!-- <img :src="file.url" /> -->
              </div>
            </div>
          </div>
        </div>

        <!-- 图片库 -->
        <div v-if="activeTab === 'imageLibrary'" class="image-library">
          <!-- 顶部标签：彩色图标 / 插图 -->
          <div class="top-tabs" style="display: flex; align-items: center">
            <div
              class="tab-item"
              v-for="tab in subTabs"
              :key="tab.value"
              :class="{ active: activeSubTab === tab.value }"
              @click="handleSubTabChange(tab.value)"
            >
              {{ tab.label }}
            </div>
            <div
              style="
                align-items: center;
                position: absolute;
                right: 45px;
                display: flex;
              "
            >
              <div v-if="selectedImage" style="padding-right: 10px">
                <span
                  >{{ currentItem.iconText }}:
                  <span style="padding: 0 10px">{{
                    tabbarActiveIndex == 1 ? "选中时" : "未选中时"
                  }}</span>
                </span>
                <i
                  v-if="selectedImage.class.includes('iconfont')"
                  :style="{
                    color: tabbarActiveIndex == 1 ? activeColor : inactiveColor,
                  }"
                  :class="selectedImage.class"
                  style="font-size: 20px"
                ></i>
                <van-icon
                  size="20"
                  v-else
                  :name="selectedImage.class"
                  :color="tabbarActiveIndex == 1 ? activeColor : inactiveColor"
                />
              </div>
              <span style="padding-right: 10px"
                >自定义颜色{{ tabbarActiveIndex }}</span
              >
              <div>
                <div>
                  <el-color-picker
                    v-if="tabbarActiveIndex == 1"
                    v-model="activeColor"
                    show-alpha
                    class="picke"
                    :predefine="predefineColors"
                  />
                </div>

                <el-color-picker
                  v-if="tabbarActiveIndex == 2"
                  v-model="inactiveColor"
                  show-alpha
                  class="picke"
                  :predefine="predefineColors"
                />
              </div>
            </div>
          </div>

          <!-- 图标网格：一次性渲染全部图标 -->
          <div
            class="icon-grid-container"
            style="height: 415px; overflow-y: auto"
          >
            <div class="image-grid">
              <div
                class="image-item"
                v-for="(icon, index) in currentIcons"
                :key="index"
                @click="selectImage(icon)"
                :class="{
                  active: selectedImage && selectedImage.name === icon.name,
                }"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  v-if="icon.class.includes('iconfont')"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="icon.class"
                    placement="top"
                  >
                    <i
                      :style="{
                        color:
                          tabbarActiveIndex == 1 ? activeColor : inactiveColor,
                      }"
                      :class="icon.class"
                    ></i>
                  </el-tooltip>
                </div>
                <div v-else>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="icon.class"
                    placement="top"
                  >
                    <van-icon
                      :name="icon.class"
                      :color="
                        tabbarActiveIndex == 1 ? activeColor : inactiveColor
                      "
                    />
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmSelection">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { predefineColors } from "@/utils/defaultData.js";
export default {
  name: "ImageSelectModal",
  props: {
    // 弹窗是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 是否显示图片库
    isImageLib: {
      type: Boolean,
      default: true,
    },
    // 活动标签：myFiles / imageLibrary
    activeTab: {
      type: String,
      default: "imageLibrary",
    },
  },
  data() {
    return {
      selectedSrc: "", //选中的图片url
      uploadedFiles: [], //已上传的文件列表
      predefineColors: predefineColors,
      activeColor: "", //自定义选中颜色
      inactiveColor: "", //自定义未选中颜色
      tabbarIndex: 0,
      tabbarActiveIndex: 0,
      dialogVisible: this.visible,
      activeSubTab: "colorIcons", // 彩色图标 / 插图
      selectedImage: null,
      subTabs: [
        { label: "彩色图标", value: "colorIcons" },
        { label: "插图", value: "illustration" },
      ],
      // ===== 去掉行业分类，直接放全量图标 =====
      //
      colorIcons: [
        "iconfont icon-tongzhi21",
        "iconfont icon-huodongyaoyue",
        "iconfont icon-wode1-copy",
        "setting-o",
        "chat-o",
        "chat",
        "location",
        "like",
        "star",
        "phone",
        "setting",
        "fire",
        "coupon",
        "cart",
        "shopping-cart",
        "cart-circle",
        "friends",
        "comment",
        "send-gift",
        "point-gift",
        "gift",
        "gem",
        "service",
        "bag",
        "todo-list",
        "balance-list",
        "checked",
        "question",
        "clock",
        "clear",
        "add",
        "gold-coin",
        "info",
        "play-circle",
        "pause-circle",
        "stop-circle",
        "warning",
        "phone-circle",
        "comment-circle",
        "smile",
        "music",
        "browsing-history",
        "underway",
        "more",
        "video",
        "share",
        "shop-collect",
        "shop",
        "smile-comment",
        "vip-card",
        "award",
        "diamond",
        "photo",
        "wap-home",
        "cluster",
        "volume",
        "gift-card",
        "expand",
        "medal",
        "good-job",
        "manager",
        "label",
        "bookmark",
        "bill",
        "new-arrival",
        "new",
        "hot-sale",
        "hot",
        "goods-collect",
        "eye",
        "delete",
        "font",
        "cash-back-record",
        "records",
        "notes",
        "contact",
        "newspaper",
        "discount",
        "completed",
        "user",
        "wechat-moments",
        "wechat-pay",
        "wechat",
        "description",
        "qq",
        "alipay",
        "weibo",
        "photograph",
        "printer",
        "bell",
        "umbrella-circle",
        "youzan-shield",
        "map-marked",
        "card",
        "add-square",
        "live",
        "column",
        "graphic",
        "audio",
        "lock",
        "invitation",
        "play",
        "pause",
        "stop",
        "weapp-nav",
        "ascending",
        "descending",
        "bars",
        "wap-nav",
        "enlarge",
        "photo-fail",
        "sort",
      ],
      // /插图
      illustrationIcons: ["https://b.yzcdn.cn/vant/icon-demo-1126.png"],
      currentItem: {},
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      },
    },
    // 当前展示的图标列表（全量，不再按行业过滤）
    currentIcons() {
      const src =
        this.activeSubTab === "colorIcons"
          ? this.colorIcons
          : this.illustrationIcons;
      return src.map((cls, idx) => ({
        class: cls,
        name: `${this.activeSubTab}-${idx}`,
      }));
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
  },
  methods: {
    echo(obj) {
      this.currentItem = obj.currentItem;
      const activeItem = this.currentIcons.find(
        (item) => item.class === obj.className
      );
      if (activeItem) {
        this.selectedImage = activeItem;
      } else {
        this.selectedImage = null;
      }
      this.activeColor = obj.activeColor;
      this.inactiveColor = obj.inactiveColor;
      console.log(
        "回显el",
        obj,
        this.currentIcons,
        activeItem,
        this.selectedImage,
        this.activeColor,
        this.inactiveColor
      );
    },
    // 上传成功回调
    handleUploadSuccess(res, file, fileList) {
      console.log("ImageSelctModal子组件上传成功回调函数", res, file, fileList);
      this.uploadedFiles = fileList.map((item) => ({
        url: item.response ? item.response.data : item.url,
        name: item.name,
      }));
    },
    closeDialog() {
      this.$emit("update:visible", false); //同步父组件关闭更新
      this.dialogVisible = false;
      console.log("关闭回调了");
    },
    handleSubTabChange(val) {
      this.activeSubTab = val;
    },
    selectImage(icon) {
      this.selectedImage = icon;
      this.selectedSrc = icon.url;
      console.log("选中的图标", icon, this.selectedImage, this.currentIcons);
    },
    confirmSelection() {
      console.log("this.selectedImage", this.selectedImage);
      if (!this.selectedImage) {
        this.$message.warning("请选择一张图标");
        return;
      }
      const obj = {
        tabbarIndex: this.tabbarIndex,
        tabbarActiveIndex: this.tabbarActiveIndex,
        ...this.selectedImage,
        activeColor: this.activeColor, //选中的颜色
        inactiveColor: this.inactiveColor, //未选中的颜色
      };
      this.$emit("select", obj);
      this.$emit("update:visible", false); //同步父组件关闭更新
      this.dialogVisible = false;
      console.log("子组件的参数", obj, this.activeColor, this.inactiveColor);
    },
  },
};
</script>

<style lang="scss" scoped>
.uploadIMG {
  .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #e0e0e0;
  }

  .el-dialog__title {
    font-size: 16px;
    font-weight: normal;
    color: #333;
  }

  .el-dialog__body {
    padding: 0;
  }

  .uploadIMGBody {
    display: flex;
    height: 500px;
    overflow: hidden;
  }

  // 左侧导航
  .left-nav {
    width: 120px;
    border-right: 1px solid #e0e0e0;
    background-color: #f5f5f5;

    .nav-item {
      padding: 15px 20px;
      cursor: pointer;
      color: #666;
      border-bottom: 1px solid #e0e0e0;
      transition: all 0.3s;

      &:hover {
        background-color: #e8e8e8;
      }

      &.active {
        background-color: #fff;
        color: #1989fa;
        border-left: 3px solid #1989fa;
      }
    }
  }

  // 右侧内容
  .right-content {
    flex: 1;
    padding: 20px;
    // overflow-y: auto;
    // 我的文件
    .my-files {
      .upload-area {
        margin-bottom: 20px;
        .upload-demo {
          border: 2px dashed #d9d9d9;
          border-radius: 6px;
          padding: 40px 20px;
          text-align: center;
          background-color: #fafafa;
          transition: border-color 0.3s;

          &:hover {
            border-color: #409eff;
          }
        }
      }

      .uploaded-files {
        .files-title {
          font-size: 14px;
          color: #333;
          margin-bottom: 10px;
        }

        /* 已上传文件列表 */
        .files-list {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
          .file-item {
            width: 80px;
            height: 80px;
            border: 2px solid transparent;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            &.active {
              border-color: #409eff;
            }
          }
        }
      }
    }

    // 图片库
    .image-library {
      // 顶部标签
      .top-tabs {
        display: flex;
        margin-bottom: 20px;
        border-bottom: 1px solid #e0e0e0;

        .tab-item {
          padding: 8px 20px;
          cursor: pointer;
          color: #666;
          margin-right: 10px;
          border-bottom: 2px solid transparent;
          transition: all 0.3s;

          &:hover {
            color: #1989fa;
          }

          &.active {
            color: #1989fa;
            border-bottom-color: #1989fa;
          }
        }
      }
      .icon-categories {
        margin-bottom: 10px;
        .tag {
          cursor: pointer;
          margin-right: 10px;
        }
      }

      // 图片分类
      .image-categories {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
        gap: 10px;

        .category-item {
          padding: 6px 15px;
          cursor: pointer;
          color: #666;
          background-color: #f5f5f5;
          border-radius: 4px;
          font-size: 13px;
          transition: all 0.3s;

          &:hover {
            background-color: #e8e8e8;
            color: #333;
          }

          &.active {
            background-color: #1989fa;
            color: #fff;
          }
        }
      }

      // 颜色选择
      .color-selector {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .color-label {
          font-size: 14px;
          color: #666;
          margin-right: 10px;
        }

        .color-option {
          padding: 6px 15px;
          cursor: pointer;
          color: #666;
          background-color: #f5f5f5;
          border-radius: 4px;
          font-size: 13px;
          margin-right: 10px;
          transition: all 0.3s;

          &:hover {
            background-color: #e8e8e8;
            color: #333;
          }

          &.active {
            background-color: #1989fa;
            color: #fff;
          }
        }
      }

      /* 图标网格 */
      .image-grid {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        .image-item {
          width: 50%;
          aspect-ratio: 1 / 1;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 32px;
          color: #666;
          background: #f5f5f5;
          border-radius: 4px;
          cursor: pointer;
          border: 2px solid transparent;
          transition: all 0.3s;
          i {
            font-size: inherit;
          }
          &:hover {
            border-color: #409eff;
            box-shadow: 0 2px 8px rgba(25, 137, 250, 0.3);
          }
          &.active {
            border-color: red;
            background: #ecf5ff;
          }
        }
      }
    }
  }

  // 底部按钮
  .dialog-footer {
    text-align: right;
    padding: 15px 20px;
    // border-top: 1px solid #e0e0e0;
  }
}
</style>
